import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const RegistrationSuccess = () => {
  const location = useLocation();
  const email = location.state?.email || 'your email';

  return (
    <div className="registration-success-page" style={{
      minHeight: 'calc(100vh - 60px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px'
    }}>
      <div className="container" style={{
        maxWidth: '650px',
        width: '100%',
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        borderRadius: '16px',
        padding: '50px 40px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        textAlign: 'center'
      }}>
        {/* Success Icon with Email */}
        <div style={{ marginBottom: '30px' }}>
          <div style={{
            width: '100px',
            height: '100px',
            margin: '0 auto 20px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 8px 30px rgba(216, 134, 255, 0.5)',
            animation: 'pulse 2s ease-in-out infinite'
          }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <style>{`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
                box-shadow: 0 8px 30px rgba(216, 134, 255, 0.5);
              }
              50% {
                transform: scale(1.05);
                box-shadow: 0 12px 40px rgba(216, 134, 255, 0.7);
              }
            }
          `}</style>
        </div>

        <h1 style={{
          marginBottom: '20px',
          color: 'var(--pink)',
          fontSize: '2rem',
          fontWeight: 'bold'
        }}>
          Check Your Email!
        </h1>

        <p style={{
          color: '#ccc',
          fontSize: '1.15rem',
          lineHeight: '1.6',
          marginBottom: '15px'
        }}>
          We've sent a verification email to
        </p>

        <p style={{
          color: 'var(--pink)',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          marginBottom: '30px',
          wordBreak: 'break-word'
        }}>
          {email}
        </p>

        <div style={{
          background: 'rgba(216, 134, 255, 0.1)',
          borderRadius: '12px',
          padding: '25px',
          border: '1px solid rgba(216, 134, 255, 0.3)',
          marginBottom: '30px',
          textAlign: 'left'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '20px' }}>
            <div style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: 'var(--pink)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              1
            </div>
            <div>
              <p style={{ color: '#fff', fontSize: '1rem', margin: '0', lineHeight: '1.5' }}>
                <strong>Check your inbox</strong> for an email from UnsupervisedBias
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '20px' }}>
            <div style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: 'var(--pink)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              2
            </div>
            <div>
              <p style={{ color: '#fff', fontSize: '1rem', margin: '0', lineHeight: '1.5' }}>
                <strong>Click the verification link</strong> to activate your account
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
            <div style={{
              width: '30px',
              height: '30px',
              borderRadius: '50%',
              background: 'var(--pink)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              3
            </div>
            <div>
              <p style={{ color: '#fff', fontSize: '1rem', margin: '0', lineHeight: '1.5' }}>
                <strong>Sign in to your account</strong> and start exploring
              </p>
            </div>
          </div>
        </div>

        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          padding: '20px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          marginBottom: '40px'
        }}>
          <p style={{ color: '#ccc', fontSize: '0.95rem', marginBottom: '10px' }}>
            <strong>Didn't receive the email?</strong>
          </p>
          <p style={{ color: '#999', fontSize: '0.9rem', lineHeight: '1.6', margin: 0 }}>
            Check your spam or junk folder. The email may take a few minutes to arrive.
            If you still don't see it, contact us at{' '}
            <a href="mailto:support@unsupervisedbias.com" style={{ color: 'var(--pink)', textDecoration: 'none' }}>
              support@unsupervisedbias.com
            </a>
          </p>
        </div>

        <Link
          to="/signin"
          style={{
            display: 'inline-block',
            padding: '15px 45px',
            background: 'linear-gradient(135deg, var(--pink) 0%, var(--violet) 100%)',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            boxShadow: '0 4px 15px rgba(216, 134, 255, 0.4)',
            transition: 'all 0.3s ease',
            fontSize: '1rem'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(216, 134, 255, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(216, 134, 255, 0.4)';
          }}
        >
          Go to Sign In
        </Link>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
